import CompublishProvider from "@/contexts/compublishContext";
import { RoleProvider } from "@/contexts/roleContext";
import StorageProvider from "@/contexts/storageContext";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { createFileRoute, Outlet } from "@tanstack/react-router";
import { LoggedIn, LoggedOut, NavigateToLogin } from "common-frontend-components";

export const Route = createFileRoute("/_hub")({
    component: RouteComponent,
    staticData: {
        titleFn: null,
    },
});

function RouteComponent() {
    return (
        <>
            <LoggedOut>
                <NavigateToLogin />
            </LoggedOut>
            <LoggedIn>
                <StorageProvider>
                    <RoleProvider>
                        <CompublishProvider>
                            <Outlet />
                            <ReactQueryDevtools initialIsOpen={false} />
                        </CompublishProvider>
                    </RoleProvider>
                </StorageProvider>
            </LoggedIn>
        </>
    );
}
